import { TASK_TEXT, type TaskPriority, type TaskRepeat, type TaskTab } from '@agrogruda/shared';

/**
 * Tasks page strings (prototype #page-tasks lines 1136-1176, #taskModal lines 1284-1295, dashboard card lines
 * 976-977 and the JS at 2295-2332 — the JS texts live in TASK_TEXT of packages/shared). Unless marked NEW every
 * string is copied character-for-character from the prototype. NEW strings exist because the device-local “Kush po
 * punon?” picker is gone (every staff login sees all the tasks) and because Web Push did not exist.
 */
export const tasksText = {
  page: {
    title: 'Detyrat e punëtorëve',
    defaultSubtitle: 'Cakto punët, afatet dhe përcill çka është kryer.',
    newTask: '+ Cakto detyrë',
    processGuide: 'Procesi i detyrës',
    searchLabel: 'Kërko detyrën',
    searchPlaceholder: 'Kërko detyrën ose përshkrimin...',
    employeeFilter: 'Punëtori',
    allEmployees: 'Krejt punëtorët',
    tabsLabel: 'Kategoritë e detyrave',
    /** NEW — the staff see every task (the prototype showed them only their own). */
    staffSubtitle: 'Po i sheh detyrat e krejt punëtorëve dhe mund ta ndryshosh progresin e secilës.',
  },
  guide: [
    { pct: '0%', label: 'Caktuar' },
    { pct: '25%', label: 'Filluar' },
    { pct: '50%', label: 'Në proces' },
    { pct: '75%', label: 'Afër përfundimit' },
    { pct: '100%', label: 'Kryer' },
  ],
  team: {
    title: 'Përmbledhja e ekipit',
    subtitle: 'Aktive, detyrat e sotme, të vonuarat dhe të kryerat për secilin punëtor.',
    columns: {
      employee: 'Punëtori',
      active: 'Aktive',
      today: 'Sot',
      avg: 'Progresi mesatar',
      overdue: 'Vonuara',
      doneMonth: 'Kryera këtë muaj',
    },
  },
  modal: {
    createTitle: 'Cakto detyrë',
    editTitle: 'Edito detyrën',
    /** NEW — the prototype's “… kur zgjedh emrin e vet te Detyrat” no longer applies. */
    subtitle: 'Stafi e sheh detyrën te Detyrat sapo ta ruash.',
    title: 'Detyra *',
    titlePlaceholder: 'p.sh. Rregullo raftin e plehrave',
    assignees: 'Punëtorët *',
    selectAll: 'Zgjedh krejt',
    clear: 'Pastro',
    priority: 'Prioriteti',
    due: 'Afati',
    time: 'Ora',
    repeat: 'Përsëritja automatike',
    description: 'Përshkrimi / udhëzimi',
    descriptionPlaceholder: 'Shkruaj saktë çka duhet me u kry...',
    howLabel: 'Si funksionon:',
    howText:
      ' Admini e cakton detyrën për një punëtor të regjistruar te Pjesëmarrja. Stafi i sheh krejt detyrat dhe e ndryshon progresin e secilës. Kur një detyrë përsëritëse kryhet, krijohet automatikisht detyra e radhës.',
    cancel: 'Anulo',
    save: 'Ruaj detyrën',
  },
  /** NEW — Web Push permission UI (task.md §4.8 notifications). */
  push: {
    button: 'Njoftimet',
    enabled: 'Njoftimet u aktivizuan',
    denied: 'Njoftimet janë të bllokuara në shfletues',
    unsupported: 'Ky shfletues nuk i mbështet njoftimet',
    unavailable: 'Njoftimet nuk janë të disponueshme në këtë version',
    failed: 'Njoftimet nuk u aktivizuan. Provo përsëri.',
  },
} as const;

export const TASK_TAB_OPTIONS: readonly { value: TaskTab; label: string }[] = [
  { value: 'today', label: TASK_TEXT.tabs.today },
  { value: 'pending', label: TASK_TEXT.tabs.pending },
  { value: 'progress', label: TASK_TEXT.tabs.progress },
  { value: 'done', label: TASK_TEXT.tabs.done },
];

/** Prototype #taskPriority options. */
export const TASK_PRIORITY_OPTIONS: readonly { value: TaskPriority; label: string }[] = [
  { value: 'normal', label: 'Normal' },
  { value: 'high', label: 'I lartë / Urgjente' },
];

/** Prototype #taskRepeat options. */
export const TASK_REPEAT_OPTIONS: readonly { value: TaskRepeat; label: string }[] = [
  { value: 'none', label: TASK_TEXT.repeat.none },
  { value: 'daily', label: TASK_TEXT.repeat.daily },
  { value: 'weekly', label: TASK_TEXT.repeat.weekly },
  { value: 'monthly', label: TASK_TEXT.repeat.monthly },
];
